function SkeletonRow({ index }) {
  return (
    <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
      <td className="px-4 sm:px-6 py-4 text-center">
        <div
          className="inline-block h-4 w-4 rounded"
          style={{
            background: "rgba(255,255,255,0.06)",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        ></div>
      </td>
      <td className="px-4 sm:px-6 py-4">
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 sm:w-9 sm:h-9 rounded-full"
            style={{
              background: "rgba(255,255,255,0.06)",
              animation: "pulse 1.5s ease-in-out infinite",
              animationDelay: `${index * 0.08}s`,
            }}
          ></div>
          <div>
            <div
              className="h-3 w-14 rounded mb-1"
              style={{
                background: "rgba(255,255,255,0.06)",
                animation: "pulse 1.5s ease-in-out infinite",
                animationDelay: `${index * 0.08}s`,
              }}
            ></div>
            <div
              className="h-2.5 w-20 rounded"
              style={{
                background: "rgba(255,255,255,0.04)",
                animation: "pulse 1.5s ease-in-out infinite",
                animationDelay: `${index * 0.08 + 0.1}s`,
              }}
            ></div>
          </div>
        </div>
      </td>
      <td className="px-4 sm:px-6 py-4 text-right">
        <div
          className="h-4 w-24 rounded ml-auto"
          style={{
            background: "rgba(255,255,255,0.06)",
            animation: "pulse 1.5s ease-in-out infinite",
            animationDelay: `${index * 0.08}s`,
          }}
        ></div>
      </td>
      <td className="px-4 sm:px-6 py-4 text-right">
        <div
          className="h-7 w-20 rounded-full ml-auto"
          style={{
            background: "rgba(255,255,255,0.06)",
            animation: "pulse 1.5s ease-in-out infinite",
            animationDelay: `${index * 0.08}s`,
          }}
        ></div>
      </td>
    </tr>
  );
}

export default SkeletonRow;